import styled from "@emotion/styled";
import { ThemeStyle } from "assets/scss/common/theme";
import { rgba } from "emotion-rgba";


export const Wrapper = styled.div`
  min-height: 100vh;
`;

export const Main = styled.div`
  min-height: calc(100vh - 42px);
  margin-top:42px;

  .add-address {
    font-size: 16px;
    font-weight: 500;
    border-bottom: 1px solid rgba(0, 19, 37, 0.16);
    padding-bottom: 3px;
    button {
      padding-left: 0px;
      padding-right: 0px;
    }
    .title {
      margin-left: 20px;
    }
    margin-left: 20px;
    margin-right: 20px;
    width: 90%;

  }

  .bottom-fixed {
    position: fixed;
    bottom:0;
    left:0;
    right:0;
    padding:5px 20px;
    font-size: 12px;
    box-shadow: inset 0px 1px 0px rgb(0 19 37 / 16%);
    background: white;
  }

  .footer {
    font-size: 12px;
    margin-top: 25px;
    margin-bottom: 100px;
  }

  button {
    border-radius: ${({ theme }: ThemeStyle) => theme.borders.radius30};
    padding-top: 10px;
  }

  .check {
    position: absolute;
    right: ${({ theme }: ThemeStyle) => theme.addressCardCheckPosition.right};
    top: ${({ theme }: ThemeStyle) => theme.addressCardCheckPosition.top};
  }
`;

export const CardWrapper:any = styled.div`
  padding: ${({ theme }: ThemeStyle) => theme.addressCardPadding};
  margin: ${({ theme }: ThemeStyle) => theme.addressCardMargin};
  background: ${({ theme, isChecked }: any) => isChecked ? theme?.colors?.selectedAddressCardBg : ""};
  position: relative;

  &:not(:last-of-type) {
    border-bottom: ${({ theme }: ThemeStyle) => theme.borders.addressCardBorder};
  }

  .label {
    background-color: ${({ theme }: ThemeStyle) => rgba(theme.grey.G10, 0.08)};
    border-radius: 20px;
    width: 66px;
    height: 24px;
    text-align: center;
    margin-left: 4px;
    padding: 2px;
    color: rgba(0, 19, 37, 0.64);
  }

  .address {
    padding-right: 50px;
    overflow-wrap: anywhere;
  }
  .edit-address{
    position: absolute;
    right: 20px;
    color: ${({ theme }: ThemeStyle) => theme.brandtextPrimaryColor}
  }
`;

export const DefaultTitle = styled.p`
  ${({ theme }: ThemeStyle) => theme?.typography?.labelSmall};
  color: ${({ theme }: ThemeStyle) => theme.colors?.addressDefaultLabelColor};
`;

export const Name = styled.p`
  ${({ theme }: ThemeStyle) => theme?.typography?.addressName as any};
  color: ${({ theme }: ThemeStyle) => theme.colors?.titleColor};
`;

export const AddressLine = styled.p`
  ${({ theme }: ThemeStyle) => theme?.typography?.type140 as any};
  color: ${({ theme }: ThemeStyle) => theme.colors?.bankNameColor};
`;

export const AddressPhone = styled.p`
  ${({ theme }: ThemeStyle) => theme?.typography?.type140 as any};
  color: ${({ theme }: ThemeStyle) => theme.colors?.addressPhoneColor};
`;

export const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  flex-direction: ${({ theme }: ThemeStyle) => theme.addressCardFooterFlexDirection};
`;

export const EditAction = styled.div`
  ${({ theme }: ThemeStyle) => theme.addressCardAction};
  color: ${({ theme }: ThemeStyle) => theme?.brandtextPrimaryColor};
  cursor: pointer;
`;
